/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { updatePageDetails, changePage } from '@insticator/insticator-ui';
import { updataDetailDropDown } from 'state/actions/detailViewState/detailViewStatus';
// component
import StoryContentAnalyticsCard from 'material/embeds/contentanalyticscard/story/story';



/* ========== ~~~~~~~~~~ EMBED : CONTENT ANALYTICS CARD : STORY : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = () => ({});

// map actions
const mapDispatchToProps = dispatch => ({
    moveToDetailedViewAnalytics: (storyId) => {
        dispatch(updataDetailDropDown([storyId], 'STORY'));
        dispatch(updatePageDetails('dashboard/analytics/detail/storyclicks'));
        dispatch(changePage(`dashboard/analytics/detail/storyclicks`))
    }
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StoryContentAnalyticsCard);
